import { Fragment, jsx, jsxs } from "react/jsx-runtime";
import { c } from "react-compiler-runtime";
import { useEffect, useId, useRef, useState } from "react";
import classnames from "classnames";
import FormControl from "@mui/material/FormControl";
import MenuItem from "@mui/material/MenuItem";
import TextField from "@mui/material/TextField";
import { Box } from "../../Box/index.js";
import { Checkbox } from "../../Checkbox/index.js";
import { Badge, ClearButton, Label, Preloader } from "../common/index.js";
import { Typography } from "../../Typography/index.js";
import { Tooltip } from "../../Tooltip/index.js";
import SelectInput_styles from "./SelectInput.styles.js";
import { MultipleAutocomplete, SingleAutocomplete } from "./Autocompletes/index.js";
import { PopupIcon } from "./PopupIcon/index.js";
function _define_property(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if ("function" == typeof Object.getOwnPropertySymbols) ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function SelectInput_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = null != source ? source : {};
    if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    else SelectInput_ownKeys(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
    return target;
}
function _object_without_properties(source, excluded) {
    if (null == source) return {};
    var target = {}, sourceKeys, key, i;
    if ("u" > typeof Reflect && Reflect.ownKeys) {
        sourceKeys = Reflect.ownKeys(Object(source));
        for(i = 0; i < sourceKeys.length; i++){
            key = sourceKeys[i];
            if (!(excluded.indexOf(key) >= 0)) {
                if (Object.prototype.propertyIsEnumerable.call(source, key)) target[key] = source[key];
            }
        }
        return target;
    }
    target = _object_without_properties_loose(source, excluded);
    if (Object.getOwnPropertySymbols) {
        sourceKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceKeys.length; i++){
            key = sourceKeys[i];
            if (!(excluded.indexOf(key) >= 0)) {
                if (Object.prototype.propertyIsEnumerable.call(source, key)) target[key] = source[key];
            }
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (null == source) return {};
    var target = {}, sourceKeys = Object.getOwnPropertyNames(source), key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (!(excluded.indexOf(key) >= 0)) {
            if (Object.prototype.propertyIsEnumerable.call(source, key)) target[key] = source[key];
        }
    }
    return target;
}
const SelectInput = (t0)=>{
    const $ = c(40);
    const { id, label, labelIcon, value, items, onChange, onLogAction, disabled: t1, placeholder, testId, autocomplete: t2, required: t3, clearable: t4, loading: t5, tooltip, error: t6, helperText, renderOption, inputTooltipText, additionalOption, emptyOption, withoutMargins: t7 } = t0, rest = _object_without_properties(t0, [
        "id",
        "label",
        "labelIcon",
        "value",
        "items",
        "onChange",
        "onLogAction",
        "disabled",
        "placeholder",
        "testId",
        "autocomplete",
        "required",
        "clearable",
        "loading",
        "tooltip",
        "error",
        "helperText",
        "renderOption",
        "inputTooltipText",
        "additionalOption",
        "emptyOption",
        "withoutMargins"
    ]);
    const disabled = void 0 === t1 ? false : t1;
    const autocomplete = void 0 === t2 ? false : t2;
    const required = void 0 === t3 ? false : t3;
    const clearable = void 0 === t4 ? false : t4;
    const loading = void 0 === t5 ? false : t5;
    const error = void 0 === t6 ? false : t6;
    const withoutMargins = void 0 === t7 ? false : t7;
    const { classes } = SelectInput_styles();
    const reactId = useId();
    const inputId = null != id ? id : reactId;
    const [inputValue, setInputValue] = useState("");
    const [width, setWidth] = useState("auto");
    const selectRef = useRef(void 0);
    const inputRef = useRef(null);
    let t8;
    if ($[0] !== items || $[1] !== value) {
        var _items_find;
        t8 = null == (_items_find = items.find((item)=>item.value === value)) ? void 0 : _items_find.badge;
        $[0] = items;
        $[1] = value;
        $[2] = t8;
    } else t8 = $[2];
    const valueBadge = t8;
    let t9;
    if ($[3] !== items || $[4] !== value) {
        var _items_find1;
        t9 = null == (_items_find1 = items.find((item_0)=>item_0.value === value)) ? void 0 : _items_find1.color;
        $[3] = items;
        $[4] = value;
        $[5] = t9;
    } else t9 = $[5];
    const valueColorIndicator = t9;
    let t10;
    if ($[6] !== items || $[7] !== value) {
        var _items_find2;
        t10 = null == (_items_find2 = items.find((item_1)=>item_1.value === value)) ? void 0 : _items_find2.startIcon;
        $[6] = items;
        $[7] = value;
        $[8] = t10;
    } else t10 = $[8];
    const valueStartIcon = t10;
    let t11;
    if ($[9] !== items) {
        t11 = items.some(_temp);
        $[9] = items;
        $[10] = t11;
    } else t11 = $[10];
    const isThereSomeGroup = t11;
    let t12;
    if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
        t12 = ()=>{
            setInputValue("");
        };
        $[11] = t12;
    } else t12 = $[11];
    const autocompleteFocusHandler = t12;
    let t13;
    let t14;
    if ($[12] !== value) {
        t13 = ()=>{
            if (!value) setInputValue("");
        };
        t14 = [
            value
        ];
        $[12] = value;
        $[13] = t13;
        $[14] = t14;
    } else {
        t13 = $[13];
        t14 = $[14];
    }
    useEffect(t13, t14);
    let t15;
    let t16;
    if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
        t15 = ()=>{
            setWidth(inputRef.current ? `${inputRef.current.clientWidth}px` : "auto");
        };
        t16 = [];
        $[15] = t15;
        $[16] = t16;
    } else {
        t15 = $[15];
        t16 = $[16];
    }
    useEffect(t15, t16);
    let t17;
    if ($[17] !== onLogAction) {
        t17 = ()=>{
            null == onLogAction || onLogAction("\u041E\u0442\u043A\u0440\u044B\u0442\u044C \u0432\u044B\u043F\u0430\u0434\u0430\u044E\u0449\u0438\u0439 \u0441\u043F\u0438\u0441\u043E\u043A");
        };
        $[17] = onLogAction;
        $[18] = t17;
    } else t17 = $[18];
    const handlePopoverOpen = t17;
    const valueIfMultiple = rest.multiple && !value ? [] : value;
    const T0 = FormControl;
    const t18 = withoutMargins && classes.withoutMargins;
    let t19;
    if ($[19] !== classes.selectInput || $[20] !== t18) {
        t19 = classnames(classes.selectInput, t18, "aqa_select_input");
        $[19] = classes.selectInput;
        $[20] = t18;
        $[21] = t19;
    } else t19 = $[21];
    let t20;
    if ($[22] !== inputId || $[23] !== label || $[24] !== labelIcon || $[25] !== required || $[26] !== tooltip) {
        t20 = label && /*#__PURE__*/ jsx(Label, {
            label: label,
            required: required,
            tooltip: tooltip,
            icon: labelIcon,
            inputId: inputId
        });
        $[22] = inputId;
        $[23] = label;
        $[24] = labelIcon;
        $[25] = required;
        $[26] = tooltip;
        $[27] = t20;
    } else t20 = $[27];
    const T1 = Tooltip;
    const t21 = "right";
    const t22 = inputTooltipText || "";
    const t23 = !inputTooltipText;
    const t24 = autocomplete ? /*#__PURE__*/ jsxs(Fragment, {
        children: [
            !rest.multiple && /*#__PURE__*/ jsx(SingleAutocomplete, _object_spread({
                label: label,
                value: value,
                items: items,
                onChange: onChange,
                disabled: disabled,
                placeholder: placeholder,
                testId: testId,
                clearable: clearable,
                loading: loading,
                error: error,
                helperText: helperText,
                renderOption: renderOption,
                emptyOption: emptyOption,
                inputValue: inputValue,
                setInputValue: setInputValue,
                isThereSomeGroup: isThereSomeGroup,
                inputId: inputId,
                handlePopoverOpen: handlePopoverOpen,
                valueBadge: valueBadge,
                valueColorIndicator: valueColorIndicator,
                onFocus: autocompleteFocusHandler
            }, rest)),
            rest.multiple && /*#__PURE__*/ jsx(MultipleAutocomplete, _object_spread({
                label: label,
                value: value,
                items: items,
                onChange: onChange,
                disabled: disabled,
                placeholder: placeholder,
                testId: testId,
                clearable: clearable,
                loading: loading,
                error: error,
                helperText: helperText,
                renderOption: renderOption,
                emptyOption: emptyOption,
                inputValue: inputValue,
                setInputValue: setInputValue,
                isThereSomeGroup: isThereSomeGroup,
                inputId: inputId,
                handlePopoverOpen: handlePopoverOpen,
                valueBadge: valueBadge,
                valueColorIndicator: valueColorIndicator,
                onFocus: autocompleteFocusHandler
            }, rest))
        ]
    }) : /*#__PURE__*/ jsxs(TextField, _object_spread_props(_object_spread({}, rest), {
        classes: {
            root: `${classes.inputRoot} ${rest.multiple ? "aqa_multiselect" : "aqa_select"}`
        },
        "data-testid": testId,
        select: !loading,
        placeholder: placeholder || label,
        value: loading ? "\u0417\u0430\u0433\u0440\u0443\u0437\u043A\u0430..." : valueIfMultiple,
        onChange: (event)=>{
            rest.multiple, onChange(event.target.value);
        },
        disabled: disabled || loading,
        variant: "outlined",
        fullWidth: true,
        error: error,
        helperText: helperText,
        slotProps: {
            input: {
                inputRef: selectRef,
                id: inputId,
                endAdornment: loading ? /*#__PURE__*/ jsx(Preloader, {}) : !disabled && clearable && !!(rest.multiple ? null == value ? void 0 : value.length : value) && /*#__PURE__*/ jsx(ClearButton, {
                    className: classes.clearButton,
                    onClick: ()=>onChange(void 0)
                }),
                startAdornment: /*#__PURE__*/ jsxs(Fragment, {
                    children: [
                        valueBadge && !loading && /*#__PURE__*/ jsx(Badge, {
                            title: valueBadge.title,
                            color: valueBadge.color,
                            description: valueBadge.description
                        }),
                        !valueBadge && !loading && valueStartIcon && /*#__PURE__*/ jsx(Box, {
                            mr: "8",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            children: valueStartIcon
                        })
                    ]
                })
            },
            select: {
                IconComponent: PopupIcon,
                onClose: _temp3,
                onOpen: handlePopoverOpen,
                multiple: rest.multiple,
                displayEmpty: true,
                MenuProps: {
                    classes: {
                        paper: classnames(classes.list, {
                            [classes.longList]: !!renderOption
                        })
                    },
                    anchorOrigin: {
                        vertical: 61,
                        horizontal: "left"
                    },
                    transformOrigin: {
                        vertical: "top",
                        horizontal: "left"
                    },
                    slotProps: {
                        paper: {
                            style: {
                                width
                            }
                        }
                    }
                },
                renderValue: (selected)=>{
                    if (Array.isArray(selected) && !selected.length || !(selected || "number" == typeof selected)) return /*#__PURE__*/ jsx("span", {
                        className: classes.placeholder,
                        children: placeholder || label
                    });
                    if (rest.multiple) {
                        if (Array.isArray(selected)) return selected.map((selectedValue)=>{
                            const selectedOption = items.find((option_0)=>option_0.value === selectedValue);
                            return selectedOption ? selectedOption.label : "-";
                        }).join(", ");
                        return "";
                    }
                    {
                        const selectedOption_0 = items.find((option_1)=>option_1.value === selected);
                        return (null == selectedOption_0 ? void 0 : selectedOption_0.label) || "";
                    }
                }
            }
        },
        children: [
            items.map((item_2)=>{
                if (item_2.disabled) return /*#__PURE__*/ jsx(MenuItem, {
                    disabled: true,
                    className: classnames(classes.menuItem, {
                        [classes.multiple]: rest.multiple,
                        [classes.defaultOption]: !renderOption && !item_2.badge
                    }),
                    onClick: (event_0)=>{
                        if (item_2.disabled) {
                            event_0.preventDefault();
                            event_0.stopPropagation();
                            return;
                        }
                    },
                    children: renderOption ? renderOption(item_2) : /*#__PURE__*/ jsxs(Fragment, {
                        children: [
                            item_2.badge && /*#__PURE__*/ jsx(Box, {
                                mr: "8",
                                children: /*#__PURE__*/ jsx(Badge, {
                                    title: item_2.badge.title,
                                    description: item_2.badge.description,
                                    color: item_2.badge.color
                                })
                            }),
                            /*#__PURE__*/ jsx(Typography, {
                                variant: "body3",
                                children: item_2.label
                            })
                        ]
                    })
                }, String(item_2.value));
                return /*#__PURE__*/ jsxs(MenuItem, {
                    className: classnames(classes.menuItem, {
                        [classes.multiple]: rest.multiple,
                        [classes.defaultOption]: !renderOption && !item_2.badge
                    }),
                    value: item_2.value,
                    onClick: _temp4,
                    children: [
                        rest.multiple && /*#__PURE__*/ jsx(Checkbox, {
                            checked: Array.isArray(value) && value.includes(item_2.value)
                        }),
                        renderOption ? renderOption(item_2) : /*#__PURE__*/ jsxs(Fragment, {
                            children: [
                                item_2.badge && /*#__PURE__*/ jsx(Box, {
                                    mr: "8",
                                    children: /*#__PURE__*/ jsx(Badge, {
                                        title: item_2.badge.title,
                                        description: item_2.badge.description,
                                        color: item_2.badge.color
                                    })
                                }),
                                /*#__PURE__*/ jsx(Typography, {
                                    variant: "body3",
                                    children: item_2.label
                                })
                            ]
                        })
                    ]
                }, String(item_2.value));
            }),
            additionalOption && !!items.length && /*#__PURE__*/ jsx(MenuItem, {
                disabled: true,
                className: classnames(classes.menuItem, classes.additionalOption),
                children: additionalOption
            }, "emptyOption"),
            emptyOption && !items.length && /*#__PURE__*/ jsx(MenuItem, {
                disabled: true,
                className: classnames(classes.menuItem, classes.additionalOption),
                children: emptyOption
            }, "emptyOption")
        ]
    }));
    let t25;
    if ($[28] !== t24) {
        t25 = /*#__PURE__*/ jsx("span", {
            children: t24
        });
        $[28] = t24;
        $[29] = t25;
    } else t25 = $[29];
    let t26;
    if ($[30] !== T1 || $[31] !== t22 || $[32] !== t23 || $[33] !== t25) {
        t26 = /*#__PURE__*/ jsx(T1, {
            placement: t21,
            title: t22,
            disabled: t23,
            children: t25
        });
        $[30] = T1;
        $[31] = t22;
        $[32] = t23;
        $[33] = t25;
        $[34] = t26;
    } else t26 = $[34];
    let t27;
    if ($[35] !== T0 || $[36] !== t19 || $[37] !== t20 || $[38] !== t26) {
        t27 = /*#__PURE__*/ jsxs(T0, {
            ref: inputRef,
            className: t19,
            children: [
                t20,
                t26
            ]
        });
        $[35] = T0;
        $[36] = t19;
        $[37] = t20;
        $[38] = t26;
        $[39] = t27;
    } else t27 = $[39];
    return t27;
};
function _temp(option) {
    return option.group;
}
function _temp2() {
    var _document_activeElement, _document;
    null == (_document = document) || null == (_document_activeElement = _document.activeElement) || _document_activeElement.blur();
}
function _temp3() {
    setTimeout(_temp2, 0);
}
function _temp4(event_1) {
    event_1.preventDefault();
    event_1.stopPropagation();
}
export { SelectInput };
